import { last } from 'gleam-shared/helpers/nodash'

export default function extractOrigin(url) {
  return last(/^(?:https?:\/\/)?[^/?&#]+/.exec(url))
}
